import { render, staticRenderFns } from "./CxCategoryApi.vue?vue&type=template&id=7d1e632a&scoped=true&"
import script from "./CxCategoryApi.vue?vue&type=script&lang=js&"
export * from "./CxCategoryApi.vue?vue&type=script&lang=js&"
import style0 from "./CxCategoryApi.vue?vue&type=style&index=0&id=7d1e632a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1e632a",
  null
  
)

export default component.exports